const getSubdomain = () => {
    if (window.location.host.split(".").length === 1) return null;
    const [subdomain] = window.location.host.replace("www.","").split(".");
    return subdomain || null;
}

export default getSubdomain;